import { styled } from '@clickcease/cc-client-components-lib'

export const ActiveTagContainer = styled('div', {
  border: '1px solid $separatorColor',
  borderRadius: '4px',
  padding: '5px 8px 5px 8px',
  display: 'flex',
  alignItems: 'center',
  marginRight: '$1',
})

export const TagText = styled('span', {
  fontSize: '$md',
  fontWeight: '$sl',
  color: '$textColor',
  marginInline: '5px',
})

export const DeleteFilterButt = styled('div', {
  all: 'unset',
  cursor: 'pointer',
  color: '$textColor',
  display: 'flex',

  ['&:hover']: {
    color: '$primaryColor',
  },
})
